export default () => ({
  pageScroll: null,
  pageAnimation: null,
  newsLimit: 2,
  translateUrl: null,
});
